'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffsetTop = getOffsetTop;
exports._event = _event;
function getOffsetTop(elem) {
  var offsetTop = 0;
  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }
  } while (elem = elem.offsetParent);
  return offsetTop;
}

var isTouchable = exports.isTouchable = 'ontouchstart' in window;
var START = exports.START = isTouchable ? 'touchstart' : 'mousedown';
var MOVE = exports.MOVE = isTouchable ? 'touchmove' : 'mousemove';
var END = exports.END = isTouchable ? 'touchend' : 'mouseup';
var CANCEL = exports.CANCEL = isTouchable ? 'touchcancel' : 'mousecancel';
var CLICK = exports.CLICK = isTouchable ? 'touchstart' : 'click';

var isBadMobile = /Android[^\d]*(1|2|3|4\.0)/.test(window.navigator.appVersion) || /iPhone[^\d]*(5)/.test(window.navigator.appVersion);

function _event(e) {
  if (e.touches && e.touches.length) {
    return e.touches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-list-view/lib/indexed-util.js
 ** module id = 443
 ** module chunks = 0
 **/